import 'magnific-popup'

export default class {

  constructor (selector) {
    this.selector = selector
  }

  init () {
    $(this.selector).magnificPopup({
      type: 'iframe',
    })
  }

}



// WEBPACK FOOTER //
// ./scripts/components/video-popup.js